var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{style:({backgroundColor: _vm.$vuetify.theme.themes.light.backgroundOryx})},[_c('v-container',{staticClass:"align-start justify-center",style:(_vm.$route.meta.reduced ? _vm.$route.name == 'product' ? 'max-width: 1024px' : 'max-width: 672px' : ''),attrs:{"fluid":!_vm.$route.meta.reduced,"fill-height":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }